import FormatGrid from 'portfolio3/features/pdf/components/FormatGrid';
import { IEntity } from 'types';

import AcademicYearTitle from '../AcademicYearTitle';
import { PdfCommonDataEntity } from '../DataEntity';

type PdfEntityByAcademicYearListProps = {
  academicYearData: [string, IEntity[]][];
};

const PdfEntityByAcademicYearList = ({ academicYearData }: PdfEntityByAcademicYearListProps) => {
  return academicYearData.map(([academicYear, data]) => (
    <div key={academicYear}>
      <AcademicYearTitle academicYear={academicYear} />
      <FormatGrid>
        {data.map((entity) => (
          <PdfCommonDataEntity key={entity.id || entity.recordId} entity={entity} />
        ))}
      </FormatGrid>
    </div>
  ));
};

export default PdfEntityByAcademicYearList;
